// @flow
import * as React from 'react';
import Radium from 'radium';
import { compose } from 'recompose';
import resizeImage from 'browser-image-resizer';

import { Colors, Sizes } from 'utils/styleguide';

const WIDTH = 96;
const HEIGHT = 96;

type Props = {
  image: ?string,
  large?: boolean,
  onImageSelected: (data: string, file: File) => void,
};

class ImageUpload extends React.Component<Props> {
  _fileupload: ?HTMLInputElement;

  _openFileDrawer = e => {
    if (!this._fileupload) {
      return;
    }
    this._fileupload.click();
  };

  _onChangeFileData = async ({ nativeEvent: { target } }) => {
    const { onImageSelected } = this.props;
    const file = target.files[0];
    if (file && file.type.startsWith('image/')) {
      const resizedFile = await resizeImage(file, {
        quality: 1,
        maxWidth: 1024,
        maxHeight: 768,
      });
      const reader = new FileReader();
      // eslint-disable-next-line
      reader.onloadend = e => {
        onImageSelected(e.target.result, file);
      };
      reader.readAsDataURL(resizedFile);
    }
  };

  _clearImage = e => {
    e.preventDefault();
    this.props.onImageSelected(null);
  };

  render() {
    const { image, large } = this.props;
    return (
      <div style={[styles.root, !!large && styles.rootLarge]}>
        <div
          style={[
            styles.image,
            !!large && styles.imageLarge,
            !!image ? { backgroundImage: `url(${image})` } : {},
            !!image ? styles.filled : styles.empty,
          ]}
          onClick={this._openFileDrawer}
        >
          {!image && <span>+</span>}
          <input
            ref={ref => (this._fileupload = ref)}
            type="file"
            style={{ display: 'none' }}
            onChange={this._onChangeFileData}
          />
        </div>
        {!!image && (
          <div style={styles.clear} onClick={this._clearImage}>
            <span>&#x2A09;</span>
          </div>
        )}
      </div>
    );
  }
}

const styles = {
  root: {
    position: 'relative',
    width: Sizes.Giga,
    height: Sizes.Giga,
  },
  rootLarge: {
    width: WIDTH,
    height: HEIGHT,
  },
  image: {
    width: Sizes.Giga,
    height: Sizes.Giga,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageLarge: {
    width: WIDTH,
    height: HEIGHT,
  },
  empty: {
    borderColor: Colors.LightGrey,
    borderWidth: 3,
    borderStyle: 'dashed',
    fontSize: 36,
    lineHeight: '36px',
    textAlign: 'center',
    color: Colors.LightGrey,
    backgroundColor: Colors.DirtyWhite,
  },
  filled: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
  },
  clear: {
    borderRadius: '50%',
    backgroundColor: Colors.Black,
    color: Colors.White,
    fontWeight: 'bold',
    fontSize: 12,
    lineHeight: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: Sizes.Micro,
    height: Sizes.Micro,
    position: 'absolute',
    top: -Sizes.Micro / 2,
    right: -Sizes.Micro / 2,
    cursor: 'pointer',
  },
};

const ImageUploadContainer = compose(Radium)(ImageUpload);

export default ImageUploadContainer;



// WEBPACK FOOTER //
// ./src/components/ImageUpload/ImageUpload.js